import axios from 'axios'
import Qs from 'qs'
import request from './request'
import router from '../router/router'

axios.defaults.withCredentials = true
export default class Net {
  static get(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        params,
        headers: {
          Authorization: sessionStorage.getItem('token')
            ? JSON.parse(sessionStorage.getItem('token'))
            : ''
        }
        // headers: { Authorization: '' }
      })
        .then((res) => {
          console.log(res)
          this.successTodo(resolve, reject, res)
        })
        .catch((error) => {
          this.errTodo(error, url)
        })
    })
  }
  static post(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data: Qs.stringify(params),
        headers: {
          Authorization: sessionStorage.getItem('token')
            ? JSON.parse(sessionStorage.getItem('token'))
            : ''
        }
        // headers: { Authorization: '' }
      })
        .then((res) => {
          this.successTodo(resolve, reject, res)
        })
        .catch((error) => {
          this.errTodo(error, url)
        })
    })
  }

  static upPic(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data: Qs.stringify(params),
        headers: {
          Authorization: sessionStorage.getItem('token')
            ? JSON.parse(sessionStorage.getItem('token'))
            : ''
        }
        // headers: { Authorization: '' }
      })
        .then((res) => {
          let retcode = parseInt(res.data.retcode)
          if (retcode === 2000000) {
            let data = res.data.result
            let param = new FormData() // 创建form对象
            param.append('key', data.dir) // 通过append向form对象添加数据
            param.append('OSSAccessKeyId', data.accessid)
            param.append('policy', data.policy)
            param.append('signature', data.signature)
            param.append('expire', data.expire)
            param.append('callback', data.callback)
            param.append('dir', 'admin/')
            param.append('file', params.file)
            // console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
            let config = {
              headers: { 'Content-Type': 'multipart/form-data' }
            } // 添加请求头
            axios
              .post(data.host, param, config)
              .then((res) => {
                console.log(data.host, 11111)
                resolve(data.host + '/' + res.data.url)
              })
              .catch(function(e) {
                console.log(e)
              })
          } else {
            this.abnormal(resolve, reject, res)
          }
        })
        .catch(() => {
          // this.errTodo(error, url);
        })
    })
  }
  // 后台返回处理500等
  static abnormal(resolve, reject, val) {
    let retcode = parseInt(val.data.retcode || val.data.status)
    if (retcode === 5001001) {
      sessionStorage.removeItem('token')
      // router.push('/login');
      // alert(val.data.msg);
      reject(val.data.msg)
    } else if (retcode === 5012004) {
      sessionStorage.removeItem('token')
      // alert(val.data.msg);
      // router.push('/login');
      reject(val.data.msg)
    } else if (retcode === 5001002) {
      // alert(val.data.msg);
      // router.push('/login');
      sessionStorage.removeItem('token')
      reject(val.data.msg)
    } else if (retcode >= 3001001 && retcode <= 3001999) {
      window.location.href = '/'
      reject(val.data.msg)
    } else if (retcode >= 3002001 && retcode <= 3002999) {
      window.location.href = '/user'
      reject(val.data.msg)
    } else {
      reject(alert(val.data.msg))
    }
  }

  // 后台正常返回方法
  static successTodo(resolve, reject, val) {
    let retcode = parseInt(val.data.retcode || val.data.status)
    if (retcode === 2000000) {
      resolve(val.data.result || val.data.res)
    } else {
      this.abnormal(resolve, reject, val)
    }
  }

  // 处理异常方法
  static errTodo(error, url) {
    // 非jsexception接口报错，post后端记录
    if (url.indexOf('jsexception') === -1) {
      request.post('/jsexception', error)
    }
    let errorCode = error.response.status
    let errorCodeFir = (error.response.status + ``).substr(0, 1)
    let msg = ''
    // console.log(error.response.status + ``);
    if (errorCodeFir === '3') {
      msg = `${errorCode}:请刷新重试!`
      alert(msg)
    } else if (errorCodeFir === '4') {
      msg = `${errorCode}:请刷新重试!`
      alert(msg)
    } else if (errorCodeFir === '5') {
      msg = `${errorCode}:请刷新重试!`
      alert(msg)
    }
  }
}
